'use client';

import React, { useEffect, useState } from 'react';

import AppImage from '@/components/ui/AppImage';

export default function LandingHero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative h-screen min-h-[600px] flex items-end overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 overflow-hidden">
        <AppImage
          src="/assets/images/IMG_7243-1775943727866.jpg"
          alt="Dartmouth Castle overlooking the River Dart estuary, Devon"
          fill
          priority
          className="object-cover animate-slow-zoom"
          sizes="100vw" />
        
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-deep-navy/20 via-deep-navy/30 to-deep-navy/80" />
      </div>

      {/* Content */}
      <div
        className={`relative z-10 w-full px-8 md:px-16 xl:px-24 pb-20 md:pb-28 transition-all duration-[1200ms] ${
        loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`
        }>
        
        {/* Date line */}
        <p className="text-xs tracking-[0.4em] uppercase font-sans font-300 text-warm-sand mb-6">
          Saturday, 29th August 2026 · Dartmouth, Devon
        </p>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 right-8 md:right-16 flex flex-col items-center gap-2 opacity-40">
        <div className="h-12 w-px bg-off-white" />
        <span className="text-xs tracking-[0.2em] uppercase font-sans text-off-white rotate-90 origin-center translate-y-6">
          Scroll
        </span>
      </div>
    </section>);

}